{
  "a-chat": [
    "people_and_communication"
  ],
  "account": [
    "people_and_communication"
  ],
  "activity": [
    "status_and_metrics"
  ],
  "add-like": [
    "actions",
    "status_and_metrics"
  ],
  "add-list": [
    "actions",
    "files_and_data"
  ],
  "add-task": [
    "actions"
  ],
  "ai": [
    "actions"
  ],
  "ai-helpdesk": [
    "people_and_communication"
  ],
  "ai-summarize": [
    "actions"
  ],
  "ai-write": [
    "actions"
  ],
  "alarm-add": [
    "status_and_metrics",
    "actions"
  ],
  "algorithm": [
    "actions"
  ],
  "animation-31": [
    "media"
  ],
  "arrow-down": [
    "navigation"
  ],
  "arrow-left": [
    "navigation"
  ],
  "arrow-right": [
    "navigation"
  ],
  "arrow-sm-down": [
    "navigation"
  ],
  "arrow-sm-left": [
    "navigation"
  ],
  "arrow-sm-right": [
    "navigation"
  ],
  "arrow-up": [
    "navigation"
  ],
  "at-sign-2": [
    "people_and_communication"
  ],
  "attach": [
    "actions",
    "files_and_data"
  ],
  "attachment": [
    "actions",
    "files_and_data"
  ],
  "auto-focus": [
    "media"
  ],
  "b-chart": [
    "status_and_metrics"
  ],
  "b-eye": [
    "actions"
  ],
  "bell": [
    "status_and_metrics"
  ],
  "bin": [
    "actions"
  ],
  "binoculars": [
    "files_and_data"
  ],
  "blockquote": [
    "actions"
  ],
  "blog": [
    "files_and_data"
  ],
  "bold": [
    "actions"
  ],
  "book-39": [
    "files_and_data"
  ],
  "book-open-2": [
    "files_and_data"
  ],
  "bookmark": [
    "status_and_metrics"
  ],
  "box-arrow-bottom-right": [
    "navigation"
  ],
  "box-arrow-top-right": [
    "navigation"
  ],
  "box-ctrl-down": [
    "navigation"
  ],
  "box-ctrl-left": [
    "navigation"
  ],
  "box-ctrl-up": [
    "navigation"
  ],
  "branch": [
    "actions"
  ],
  "bullet-list": [
    "files_and_data"
  ],
  "bullet-list-68": [
    "files_and_data"
  ],
  "bullet-list-70": [
    "files_and_data"
  ],
  "button-play": [
    "actions",
    "media"
  ],
  "button-power": [
    "actions"
  ],
  "c-add": [
    "actions"
  ],
  "c-check": [
    "status_and_metrics"
  ],
  "c-delete": [
    "actions"
  ],
  "c-info": [
    "status_and_metrics"
  ],
  "c-question": [
    "status_and_metrics"
  ],
  "c-remove": [
    "actions"
  ],
  "c-warning": [
    "status_and_metrics"
  ],
  "calendar": [
    "files_and_data"
  ],
  "calendar-2": [
    "files_and_data"
  ],
  "calendar-agenda": [
    "files_and_data"
  ],
  "calendar-day": [
    "files_and_data"
  ],
  "calendar-half": [
    "files_and_data"
  ],
  "calendar-month": [
    "files_and_data"
  ],
  "calendar-quarter": [
    "files_and_data"
  ],
  "calendar-week": [
    "files_and_data"
  ],
  "calendar-year": [
    "files_and_data"
  ],
  "cards": [
    "media"
  ],
  "caret-sm-up": [
    "navigation"
  ],
  "caret-sm-up-2": [
    "navigation"
  ],
  "centralize": [
    "navigation"
  ],
  "change": [
    "navigation"
  ],
  "change-direction": [
    "navigation"
  ],
  "chart-bar-32": [
    "status_and_metrics"
  ],
  "chat-bot": [
    "people_and_communication"
  ],
  "check": [
    "status_and_metrics"
  ],
  "check-double": [
    "status_and_metrics"
  ],
  "checkbox-btn": [
    "actions"
  ],
  "checkbox-btn-checked": [
    "actions"
  ],
  "checkbox-list": [
    "files_and_data"
  ],
  "chevron-down": [
    "navigation"
  ],
  "chevron-top": [
    "navigation"
  ],
  "clock": [
    "status_and_metrics"
  ],
  "cloud": [
    "files_and_data"
  ],
  "cloud-upload": [
    "files_and_data"
  ],
  "cog-wheel": [
    "actions"
  ],
  "collection": [
    "files_and_data"
  ],
  "column": [
    "files_and_data"
  ],
  "comment": [
    "people_and_communication"
  ],
  "comments": [
    "people_and_communication"
  ],
  "components": [
    "actions"
  ],
  "condition": [
    "actions"
  ],
  "contacts": [
    "people_and_communication"
  ],
  "copy": [
    "actions"
  ],
  "copy-2": [
    "actions"
  ],
  "cross": [
    "actions"
  ],
  "cross-small": [
    "actions"
  ],
  "crossroad": [
    "navigation"
  ],
  "d-edit": [
    "actions"
  ],
  "data-upload": [
    "files_and_data"
  ],
  "database": [
    "files_and_data"
  ],
  "delete-forever": [
    "actions"
  ],
  "device-mobile": [
    "people_and_communication"
  ],
  "digital-key": [
    "status_and_metrics"
  ],
  "directions": [
    "navigation"
  ],
  "disk": [
    "files_and_data"
  ],
  "divider": [
    "actions"
  ],
  "document": [
    "files_and_data"
  ],
  "document-copy": [
    "files_and_data"
  ],
  "documentation": [
    "files_and_data"
  ],
  "done": [
    "status_and_metrics"
  ],
  "dots": [
    "navigation"
  ],
  "double-arrow-left": [
    "navigation"
  ],
  "double-arrow-right": [
    "navigation"
  ],
  "double-check": [
    "status_and_metrics"
  ],
  "download": [
    "files_and_data"
  ],
  "drag": [
    "navigation"
  ],
  "dragger": [
    "navigation"
  ],
  "e-add": [
    "actions"
  ],
  "e-delete": [
    "actions"
  ],
  "e-remove": [
    "actions"
  ],
  "edit": [
    "actions"
  ],
  "email": [
    "people_and_communication"
  ],
  "empty": [
    "status_and_metrics"
  ],
  "engine-start": [
    "actions"
  ],
  "enlarge": [
    "navigation"
  ],
  "error": [
    "status_and_metrics"
  ],
  "expand": [
    "navigation"
  ],
  "export": [
    "files_and_data"
  ],
  "eye": [
    "actions"
  ],
  "f-add": [
    "actions"
  ],
  "f-dashboard": [
    "status_and_metrics"
  ],
  "f-remove": [
    "actions"
  ],
  "face-recognition": [
    "status_and_metrics"
  ],
  "favorite": [
    "status_and_metrics"
  ],
  "feedback": [
    "people_and_communication",
    "status_and_metrics"
  ],
  "file": [
    "files_and_data"
  ],
  "file-article": [
    "files_and_data"
  ],
  "file-audio": [
    "files_and_data",
    "media"
  ],
  "file-chart-bar": [
    "files_and_data",
    "status_and_metrics"
  ],
  "file-chart-pie": [
    "files_and_data",
    "status_and_metrics"
  ],
  "file-copies": [
    "files_and_data"
  ],
  "file-csv": [
    "files_and_data"
  ],
  "file-dev": [
    "files_and_data"
  ],
  "file-docx": [
    "files_and_data"
  ],
  "file-download": [
    "files_and_data"
  ],
  "file-export": [
    "files_and_data"
  ],
  "file-folder": [
    "files_and_data"
  ],
  "file-history": [
    "files_and_data",
    "status_and_metrics"
  ],
  "file-ics": [
    "files_and_data"
  ],
  "file-image": [
    "files_and_data",
    "media"
  ],
  "file-json": [
    "files_and_data"
  ],
  "file-md": [
    "files_and_data"
  ],
  "file-new": [
    "files_and_data"
  ],
  "file-pdf": [
    "files_and_data"
  ],
  "file-pptx": [
    "files_and_data"
  ],
  "file-question": [
    "files_and_data"
  ],
  "file-text": [
    "files_and_data"
  ],
  "file-upload": [
    "files_and_data"
  ],
  "file-user": [
    "files_and_data",
    "people_and_communication"
  ],
  "file-vector": [
    "files_and_data",
    "media"
  ],
  "file-video": [
    "files_and_data",
    "media"
  ],
  "file-xlsx": [
    "files_and_data"
  ],
  "file-zip": [
    "files_and_data"
  ],
  "filter": [
    "files_and_data"
  ],
  "filter-check": [
    "files_and_data"
  ],
  "firewall": [
    "status_and_metrics"
  ],
  "flag-points-32": [
    "status_and_metrics"
  ],
  "flash": [
    "media"
  ],
  "floppy-disk": [
    "files_and_data"
  ],
  "folder": [
    "files_and_data"
  ],
  "folder-add": [
    "files_and_data"
  ],
  "folder-user": [
    "files_and_data",
    "people_and_communication"
  ],
  "gallery-view": [
    "files_and_data"
  ],
  "group": [
    "actions"
  ],
  "heart": [
    "status_and_metrics"
  ],
  "help": [
    "status_and_metrics"
  ],
  "hierarchy": [
    "navigation"
  ],
  "hot-key": [
    "actions"
  ],
  "i-add": [
    "actions"
  ],
  "i-delete": [
    "actions"
  ],
  "i-remove": [
    "actions"
  ],
  "info": [
    "status_and_metrics"
  ],
  "journey": [
    "navigation"
  ],
  "key": [
    "status_and_metrics"
  ],
  "keyboard-arrow-down": [
    "navigation"
  ],
  "keyboard-arrow-left": [
    "navigation"
  ],
  "keyboard-arrow-right": [
    "navigation"
  ],
  "keyboard-arrow-up": [
    "navigation"
  ],
  "l-check": [
    "status_and_metrics"
  ],
  "l-circle": [
    "status_and_metrics"
  ],
  "language": [
    "people_and_communication"
  ],
  "layers": [
    "navigation"
  ],
  "leave": [
    "actions"
  ],
  "letter": [
    "people_and_communication"
  ],
  "level": [
    "status_and_metrics"
  ],
  "line-chart": [
    "status_and_metrics"
  ],
  "line-chart-cube": [
    "status_and_metrics"
  ],
  "link": [
    "actions"
  ],
  "list": [
    "files_and_data"
  ],
  "lock": [
    "status_and_metrics"
  ],
  "log-out": [
    "actions"
  ],
  "loudspeaker": [
    "media"
  ],
  "m-ai-assistant-dashboard": [
    "actions"
  ],
  "m-alerts-and-notifications": [
    "status_and_metrics"
  ],
  "m-assets-configurations": [
    "files_and_data"
  ],
  "m-attendance": [
    "status_and_metrics"
  ],
  "m-automation-buttons": [
    "actions"
  ],
  "m-automations": [
    "actions"
  ],
  "m-calendar": [
    "files_and_data"
  ],
  "m-devops": [
    "actions"
  ],
  "m-diagrams": [
    "navigation"
  ],
  "m-dms": [
    "files_and_data"
  ],
  "m-documents": [
    "files_and_data"
  ],
  "m-easy-buttons": [
    "actions"
  ],
  "m-easy-help": [
    "status_and_metrics"
  ],
  "m-easy-plugins": [
    "files_and_data"
  ],
  "m-gantt": [
    "status_and_metrics"
  ],
  "m-git-integration": [
    "actions"
  ],
  "m-helpdesk": [
    "people_and_communication"
  ],
  "m-milestones": [
    "files_and_data"
  ],
  "m-mind-maps": [
    "navigation"
  ],
  "m-payroll-and-invoicing-sheets": [
    "files_and_data"
  ],
  "m-project-templates": [
    "navigation"
  ],
  "m-resource-management": [
    "status_and_metrics"
  ],
  "m-risks": [
    "status_and_metrics"
  ],
  "m-scrum-boards": [
    "files_and_data"
  ],
  "m-sprint-dashboard": [
    "files_and_data"
  ],
  "m-task-templates": [
    "files_and_data"
  ],
  "m-tasks": [
    "files_and_data"
  ],
  "m-test-cases": [
    "files_and_data"
  ],
  "m-time-reports": [
    "files_and_data"
  ],
  "m-timesheets": [
    "files_and_data"
  ],
  "m-users": [
    "people_and_communication"
  ],
  "mail": [
    "people_and_communication"
  ],
  "medical-clipboard": [
    "files_and_data"
  ],
  "meeting": [
    "people_and_communication"
  ],
  "menu": [
    "navigation"
  ],
  "menu-6": [
    "navigation"
  ],
  "menu-8": [
    "navigation"
  ],
  "menu-more": [
    "navigation"
  ],
  "menu-rich": [
    "navigation"
  ],
  "migrate": [
    "navigation"
  ],
  "minus": [
    "actions"
  ],
  "move": [
    "navigation"
  ],
  "move-left": [
    "navigation"
  ],
  "move-right": [
    "navigation"
  ],
  "move-to-board": [
    "navigation"
  ],
  "move-up-2": [
    "navigation"
  ],
  "msgs": [
    "people_and_communication"
  ],
  "n-check": [
    "status_and_metrics"
  ],
  "networking": [
    "people_and_communication"
  ],
  "news": [
    "files_and_data"
  ],
  "note": [
    "files_and_data"
  ],
  "notepad": [
    "files_and_data"
  ],
  "notes": [
    "files_and_data"
  ],
  "o-warning": [
    "status_and_metrics"
  ],
  "open-folder": [
    "files_and_data"
  ],
  "open-modal": [
    "navigation"
  ],
  "open-window": [
    "navigation"
  ],
  "options": [
    "actions"
  ],
  "p-add": [
    "actions"
  ],
  "p-edit": [
    "actions"
  ],
  "palette": [
    "media"
  ],
  "paragraph": [
    "actions"
  ],
  "pause": [
    "actions"
  ],
  "pen": [
    "actions"
  ],
  "pencil": [
    "actions"
  ],
  "pennant": [
    "status_and_metrics"
  ],
  "phone": [
    "people_and_communication"
  ],
  "pin": [
    "navigation"
  ],
  "play": [
    "actions"
  ],
  "play-media": [
    "media"
  ],
  "plus": [
    "actions"
  ],
  "pointing-left": [
    "navigation"
  ],
  "pointing-right": [
    "navigation"
  ],
  "position-pin": [
    "navigation"
  ],
  "print": [
    "actions"
  ],
  "printer": [
    "actions"
  ],
  "priority": [
    "status_and_metrics"
  ],
  "profile": [
    "people_and_communication"
  ],
  "progress": [
    "status_and_metrics"
  ],
  "puzzle-10": [
    "actions"
  ],
  "radiation": [
    "status_and_metrics"
  ],
  "radio-btn": [
    "actions"
  ],
  "radio-btn-checked": [
    "actions"
  ],
  "redo": [
    "actions"
  ],
  "refresh-02": [
    "actions"
  ],
  "reload": [
    "actions"
  ],
  "remove-like": [
    "actions",
    "status_and_metrics"
  ],
  "repeat": [
    "actions"
  ],
  "repeat-cycle": [
    "actions"
  ],
  "resize-x": [
    "navigation"
  ],
  "resize-y": [
    "navigation"
  ],
  "robot": [
    "actions"
  ],
  "s-add": [
    "actions"
  ],
  "s-delete": [
    "actions"
  ],
  "s-edit": [
    "actions"
  ],
  "s-info": [
    "status_and_metrics"
  ],
  "s-plus": [
    "actions"
  ],
  "s-question": [
    "status_and_metrics"
  ],
  "s-remove": [
    "actions"
  ],
  "s-warning": [
    "status_and_metrics"
  ],
  "scissors": [
    "actions"
  ],
  "search": [
    "files_and_data"
  ],
  "search-content": [
    "files_and_data"
  ],
  "security": [
    "status_and_metrics"
  ],
  "send": [
    "people_and_communication"
  ],
  "send-to-phone": [
    "actions"
  ],
  "server-rack": [
    "files_and_data"
  ],
  "settings": [
    "actions"
  ],
  "setup-preferences": [
    "actions"
  ],
  "share": [
    "actions"
  ],
  "slide-left": [
    "navigation"
  ],
  "slide-right": [
    "navigation"
  ],
  "sort": [
    "navigation"
  ],
  "sort-tool": [
    "navigation"
  ],
  "sorting": [
    "navigation"
  ],
  "split-branch": [
    "actions"
  ],
  "star": [
    "status_and_metrics"
  ],
  "strikethrough": [
    "actions"
  ],
  "subscript": [
    "actions"
  ],
  "success": [
    "status_and_metrics"
  ],
  "superscript": [
    "actions"
  ],
  "switch-off": [
    "actions"
  ],
  "switch-on": [
    "actions"
  ],
  "sync-devices": [
    "actions"
  ],
  "tag-add": [
    "actions"
  ],
  "tag-remove": [
    "actions"
  ],
  "task-add": [
    "actions"
  ],
  "text": [
    "actions"
  ],
  "text-align-justify": [
    "actions"
  ],
  "theater": [
    "media"
  ],
  "thumb-down": [
    "status_and_metrics"
  ],
  "thumb-up": [
    "status_and_metrics"
  ],
  "time-clock": [
    "status_and_metrics"
  ],
  "timeline": [
    "status_and_metrics"
  ],
  "timer": [
    "status_and_metrics"
  ],
  "todo": [
    "files_and_data"
  ],
  "tool-hand": [
    "navigation"
  ],
  "trash": [
    "actions"
  ],
  "trend-down": [
    "status_and_metrics"
  ],
  "trend-up": [
    "status_and_metrics"
  ],
  "triangle": [
    "navigation"
  ],
  "turn-off": [
    "actions"
  ],
  "type-tool": [
    "actions"
  ],
  "underline": [
    "actions"
  ],
  "undo": [
    "actions"
  ],
  "unlink": [
    "actions"
  ],
  "unlocked": [
    "status_and_metrics"
  ],
  "update": [
    "actions"
  ],
  "upload": [
    "files_and_data"
  ],
  "user": [
    "people_and_communication"
  ],
  "user-add": [
    "people_and_communication",
    "actions"
  ],
  "user-create": [
    "people_and_communication",
    "actions"
  ],
  "user-delete": [
    "people_and_communication",
    "actions"
  ],
  "user-group": [
    "people_and_communication"
  ],
  "users": [
    "people_and_communication"
  ],
  "users-meeting": [
    "people_and_communication"
  ],
  "users-mm": [
    "people_and_communication"
  ],
  "users-wm": [
    "people_and_communication"
  ],
  "video": [
    "media"
  ],
  "video-gallery-2": [
    "media"
  ],
  "video-playlist": [
    "media"
  ],
  "volume-2": [
    "media"
  ],
  "volume-down": [
    "media"
  ],
  "warning": [
    "status_and_metrics"
  ],
  "warning-sign": [
    "status_and_metrics"
  ],
  "webhook": [
    "actions"
  ],
  "window-add": [
    "actions"
  ],
  "window-maximize": [
    "navigation"
  ],
  "wireframe": [
    "files_and_data"
  ],
  "zipped-file": [
    "files_and_data"
  ],
  "zoom-in": [
    "files_and_data"
  ],
  "zoom-minus": [
    "files_and_data"
  ],
  "zoom-out": [
    "files_and_data"
  ],
  "zoom-plus": [
    "files_and_data"
  ]
}
